/* tslint:disable */
import { Injectable } from '@angular/core';
import { User } from '../../models/User';
import { Budget } from '../../models/Budget';
import { Currency } from '../../models/Currency';
import { Category } from '../../models/Category';
import { Type } from '../../models/Type';
import { Member } from '../../models/Member';
import { Actual } from '../../models/Actual';
import { StorageActual } from '../../models/StorageActual';

export interface Models { [name: string]: any }

@Injectable()
export class SDKModels {

  private models: Models = {
    User: User,
    Budget: Budget,
    Currency: Currency,
    Category: Category,
    Type: Type,
    Member: Member,
    Actual: Actual,
    StorageActual: StorageActual,
    
  };

  public get(modelName: string): any {
    return this.models[modelName];
  }

  public getAll(): Models {
    return this.models;
  }

  public getModelNames(): string[] {
    return Object.keys(this.models);
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk-budget/services/custom/SDKModels.ts